import { getFieldProperty } from '../configs/config-actions';
import { SCRAPER_REQ_FIELD_KEY } from '../configs/scraper-field-map/field-const';
import type { SCRAPER_NAME as ScraperName } from '../types';
import { SCRAPER_NAME } from '../types';
import { AllOptionsField } from './Fields/AllOptionsField';
import { BrandField } from './Fields/BrandField';
import { CafeIdField } from './Fields/CafeIdField';
import { CafeNameField } from './Fields/CafeNameField';
import { ExactMatchField } from './Fields/ExactMatchField';
import { GroupAliasField } from './Fields/group-alias-field';
import { DefinitionField, KeywordField } from './Fields/KeywordField';
import { KeywordFilterField } from './Fields/KeywordFilterField';
import { KeywordsField } from './Fields/KeywordsField';
import { LinkField } from './Fields/LinkField';
import { LinksField } from './Fields/LinksField';
import { PageUrlField } from './Fields/PageUrlField';
import { ProductLineField } from './Fields/ProductLineField';
import { ProductNameField } from './Fields/ProductNameField';
import { SortField } from './Fields/SortField';
import { SubredditField } from './Fields/SubredditField';
import { UsernameField } from './Fields/UsernameField';

const NAVER_SCRAPER_NAMES: readonly ScraperName[] = [
  SCRAPER_NAME.NaverBlogPost,
  SCRAPER_NAME.NaverCafeAccountBase,
  SCRAPER_NAME.NaverCafeAllSearch,
  SCRAPER_NAME.NaverCafeInSearch,
  SCRAPER_NAME.NaverSpecificCafeSearch,
  SCRAPER_NAME.NaverStoreReviewByUrl,
];

export const FieldMapper = (props: {
  scraping_field: SCRAPER_REQ_FIELD_KEY;
  scraper_name: ScraperName;
}) => {
  const { scraping_field, scraper_name } = props;
  const fieldProperty = getFieldProperty(scraping_field, scraper_name);
  const required = fieldProperty?.required || false;
  const isNaverScraper = NAVER_SCRAPER_NAMES.some(
    (naverScraperName) => naverScraperName === scraper_name,
  );

  switch (scraping_field) {
    case SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE:
      return <ProductLineField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.BRAND:
      return <BrandField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME:
      return <ProductNameField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.LINKS:
      return <LinksField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.LINK:
      return <LinkField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.USERNAME:
      return <UsernameField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.KEYWORD:
      return <KeywordField required={required} showTooltip={!isNaverScraper} />;
    case SCRAPER_REQ_FIELD_KEY.DEFINITION:
      return <DefinitionField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.PAGE_URL:
      return <PageUrlField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.GROUP_ALIAS:
      return <GroupAliasField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.CAFE_ID:
      return <CafeIdField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.CAFE_NAME:
      return <CafeNameField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.EXACT_MATCH:
      return <ExactMatchField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.SORT:
      return <SortField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.KEYWORDS:
      return <KeywordsField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.SUBREDDIT:
      return <SubredditField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.ALL_OPTIONS:
      return <AllOptionsField required={required} />;
    case SCRAPER_REQ_FIELD_KEY.INCLUDE_KEYWORDS:
      return (
        <KeywordFilterField
          required={required}
          filterType={SCRAPER_REQ_FIELD_KEY.INCLUDE_KEYWORDS}
        />
      );
    case SCRAPER_REQ_FIELD_KEY.EXCLUDE_KEYWORDS:
      return (
        <KeywordFilterField
          required={required}
          filterType={SCRAPER_REQ_FIELD_KEY.EXCLUDE_KEYWORDS}
        />
      );
    default:
      return null;
  }
};
